import { ROUTES, withPeek } from "@/app/routes";
import type { EntityRefSummary } from "@/domain/entityRef";

export function entityRefLink(
  subject: EntityRefSummary,
  beneficiaryUuid?: string | null,
  quotaUuid?: string | null,
): string | null {
  if (subject.status === "deleted") return null;
  const uuid = subject.entity_uuid;
  const parent = subject.parent;
  const beneficiary =
    beneficiaryUuid ?? (parent?.entity_type === "beneficiary" ? parent.entity_uuid : null);
  const quota = quotaUuid ?? (parent?.entity_type === "fiscal_quota" ? parent.entity_uuid : null);
  switch (subject.entity_type) {
    case "investor":
      return withPeek(ROUTES.INVESTMENTS.INVESTORS, uuid);
    case "investment":
      return withPeek(ROUTES.INVESTMENTS.MAIN, uuid);
    case "beneficiary":
      return withPeek(ROUTES.BENEFICIARIES.LIST, uuid);
    case "fiscal_quota":
      return withPeek(ROUTES.QUOTAS, uuid);
    case "document":
      return withPeek(ROUTES.INVESTMENTS.CONTRACTS, uuid);
    case "project":
      return beneficiary
        ? `${withPeek(ROUTES.BENEFICIARIES.LIST, beneficiary)}&project=${encodeURIComponent(uuid)}`
        : null;
    case "classification":
      return beneficiary && quota
        ? withPeek(ROUTES.BENEFICIARIES.AUDIT(beneficiary, quota), uuid)
        : null;
    case "audit":
      return beneficiary && quota ? ROUTES.BENEFICIARIES.AUDIT(beneficiary, quota) : null;
    case "template":
      return ROUTES.ORGANIZATION.TEMPLATE_DETAIL(uuid);
    case "investment_proposal":
      return parent?.entity_type === "investor"
        ? ROUTES.INVESTORS.PROPOSAL(parent.entity_uuid, uuid)
        : null;
    case "organization":
      return ROUTES.ORGANIZATION.GENERAL;
    case "user":
      return ROUTES.ORGANIZATION.USERS;
    case "beneficiary_bank_account":
    case "beneficiary_legal_representative":
      return beneficiary ? ROUTES.BENEFICIARIES.DETAIL(beneficiary) : null;
    default:
      return null;
  }
}
